/**
 * Mascarade Noire — moteur d'effets global (léger, additif, sans dépendance).
 * Ne touche à rien du panier / checkout / composants existants du thème.
 */
(function () {
  'use strict';

  var cfg = (window.MascaradeConfig && window.MascaradeConfig.effects) || {};
  var reduceMotionMQ = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prefersReducedMotion() {
    try {
      var stored = localStorage.getItem('mn-reduced-motion');
      if (stored === 'true') return true;
      if (stored === 'false') return false;
    } catch (e) {}
    return reduceMotionMQ.matches;
  }

  function applyMotionState(reduced) {
    document.documentElement.setAttribute('data-mn-reduced-motion', reduced ? 'true' : 'false');
    var btn = document.querySelector('.mn-motion-toggle');
    if (btn) {
      btn.setAttribute('aria-pressed', reduced ? 'true' : 'false');
      btn.textContent = reduced ? '🕯️ Animations réduites' : '🕯️ Réduire les animations';
    }
  }

  function initMotionToggle() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mn-motion-toggle';
    btn.setAttribute('aria-pressed', prefersReducedMotion() ? 'true' : 'false');
    btn.textContent = prefersReducedMotion() ? '🕯️ Animations réduites' : '🕯️ Réduire les animations';
    btn.addEventListener('click', function () {
      var next = document.documentElement.getAttribute('data-mn-reduced-motion') !== 'true';
      try {
        localStorage.setItem('mn-reduced-motion', String(next));
      } catch (e) {}
      applyMotionState(next);
    });
    document.body.appendChild(btn);
    applyMotionState(prefersReducedMotion());
  }

  function initScrollReveal() {
    if (cfg.scrollReveal === false) return;
    var items = document.querySelectorAll('.mn-reveal');
    if (!items.length) return;

    if (!('IntersectionObserver' in window) || prefersReducedMotion()) {
      items.forEach(function (el) {
        el.classList.add('mn-in-view');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mn-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      // Seuil 0 + marge : les très grandes sections (Bestiaire, Offrandes)
      // apparaissent dès que leur haut entre à l'écran, sans « trou » noir.
      { threshold: 0, rootMargin: '0px 0px -10% 0px' }
    );

    items.forEach(function (el, i) {
      el.style.setProperty('--mn-stagger-index', i % 6);
      observer.observe(el);
    });
  }

  function initCandleProgress() {
    if (cfg.candleProgress === false) return;
    var wrap = document.createElement('div');
    wrap.className = 'mn-candle-progress';
    wrap.setAttribute('aria-hidden', 'true');
    var fill = document.createElement('div');
    fill.className = 'mn-candle-progress__fill';
    wrap.appendChild(fill);
    document.body.appendChild(wrap);

    // Sur ordinateur, le thème Horizon fait défiler .page-wrapper (et non la
    // fenêtre) : on mesure le conteneur qui défile réellement.
    function getScroller() {
      var wrapper = document.querySelector('.page-wrapper');
      if (wrapper && wrapper.scrollHeight > wrapper.clientHeight + 1) {
        var ov = window.getComputedStyle(wrapper).overflowY;
        if (ov === 'auto' || ov === 'scroll') return wrapper;
      }
      return document.scrollingElement || document.documentElement;
    }

    var ticking = false;
    function update() {
      var scroller = getScroller();
      var scrollTop = scroller.scrollTop;
      var height = scroller.scrollHeight - scroller.clientHeight;
      var ratio = height > 0 ? Math.min(1, Math.max(0, scrollTop / height)) : 0;
      fill.style.transform = 'scaleX(' + ratio.toFixed(4) + ')';
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }
    // capture : reçoit aussi le défilement de .page-wrapper (qui ne remonte pas jusqu'à window)
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function initFlashCursor() {
    if (cfg.customCursor === false) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (prefersReducedMotion()) return;

    var dot = document.createElement('div');
    dot.className = 'mn-flash-cursor';
    dot.setAttribute('aria-hidden', 'true');
    document.body.appendChild(dot);

    var enabled = false;
    window.addEventListener(
      'pointermove',
      function (e) {
        if (!enabled) {
          enabled = true;
          document.documentElement.classList.add('mn-cursor-active');
        }
        dot.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px) translate(-50%,-50%)';
      },
      { passive: true }
    );
    document.addEventListener('pointerleave', function () {
      dot.style.opacity = '0';
    });
    document.addEventListener('pointerenter', function () {
      dot.style.opacity = '1';
    });
  }

  function initBatTrail() {
    if (cfg.batTrail === false) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (prefersReducedMotion()) return;

    var COUNT = 4;
    var bats = [];
    var container = document.createElement('div');
    container.setAttribute('aria-hidden', 'true');

    for (var i = 0; i < COUNT; i++) {
      var bat = document.createElement('span');
      bat.className = 'mn-bat-trail';
      bat.style.setProperty('--mn-bat-opacity', Math.max(0.15, 0.75 - i * 0.15).toFixed(2));
      var flap = document.createElement('span');
      flap.className = 'mn-bat-trail__flap';
      flap.textContent = '🦇';
      bat.appendChild(flap);
      container.appendChild(bat);
      bats.push({ el: bat, x: -100, y: -100 });
    }
    document.body.appendChild(container);

    var mouse = { x: -100, y: -100 };
    var active = false;

    window.addEventListener(
      'pointermove',
      function (e) {
        mouse.x = e.clientX;
        mouse.y = e.clientY;
        if (!active) {
          active = true;
          bats.forEach(function (b) {
            b.x = mouse.x;
            b.y = mouse.y;
            b.el.classList.add('is-active');
          });
        }
      },
      { passive: true }
    );
    document.addEventListener('pointerleave', function () {
      active = false;
      bats.forEach(function (b) {
        b.el.classList.remove('is-active');
      });
    });

    function loop() {
      if (active && !document.hidden) {
        var target = mouse;
        bats.forEach(function (b, i) {
          var ease = 0.22 - i * 0.03;
          b.x += (target.x - b.x) * ease;
          b.y += (target.y - b.y) * ease;
          b.el.style.transform = 'translate(' + b.x + 'px,' + b.y + 'px) translate(-50%,-50%)';
          target = b;
        });
      }
      window.requestAnimationFrame(loop);
    }
    window.requestAnimationFrame(loop);
  }

  function initEmbers() {
    if (cfg.embers === false) return;
    if (prefersReducedMotion()) return;

    var container = document.createElement('div');
    container.className = 'mn-embers';
    container.setAttribute('aria-hidden', 'true');

    var COUNT = window.matchMedia('(max-width: 700px)').matches ? 7 : 14;
    for (var i = 0; i < COUNT; i++) {
      var ember = document.createElement('span');
      ember.className = 'mn-ember';
      var left = Math.random() * 100;
      var duration = 9 + Math.random() * 10;
      var delay = Math.random() * duration * -1;
      var drift = (Math.random() * 60 - 30).toFixed(0) + 'px';
      ember.style.left = left + '%';
      ember.style.animationDuration = duration + 's';
      ember.style.animationDelay = delay + 's';
      ember.style.setProperty('--mn-ember-drift', drift);
      container.appendChild(ember);
    }
    document.body.appendChild(container);
  }

  function initFog() {
    if (cfg.fog === false) return;
    if (prefersReducedMotion()) return;

    var fog = document.createElement('div');
    fog.className = 'mn-fog';
    fog.setAttribute('aria-hidden', 'true');
    document.body.appendChild(fog);

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        fog.classList.add('is-active');
      });
    });
  }

  function initVisibilityPause() {
    document.addEventListener('visibilitychange', function () {
      document.documentElement.classList.toggle('mn-tab-hidden', document.hidden);
    });
  }

  function initCountdowns() {
    if (!window.MascaradeConfig) return;
    var roots = document.querySelectorAll('[data-mn-countdown]');
    if (!roots.length) return;

    var mcfg = window.MascaradeConfig;
    var halloween = new Date(mcfg.halloweenDate);

    function pad(n) {
      return String(Math.max(0, n)).padStart(2, '0');
    }

    roots.forEach(function (root) {
      if (root.dataset.mnCountdownInit === 'true') return;
      root.dataset.mnCountdownInit = 'true';

      var now = new Date();
      if (now > halloween) return;

      root.hidden = false;

      function tick() {
        var diff = halloween.getTime() - Date.now();
        if (diff <= 0) {
          root.hidden = true;
          clearInterval(timer);
          return;
        }
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);

        var d = root.querySelector('[data-mn-days]');
        var h = root.querySelector('[data-mn-hours]');
        var m = root.querySelector('[data-mn-minutes]');
        var s = root.querySelector('[data-mn-seconds]');
        if (d) d.textContent = pad(days);
        if (h) h.textContent = pad(hours);
        if (m) m.textContent = pad(minutes);
        if (s) s.textContent = pad(seconds);
      }

      var timer = setInterval(tick, 1000);
      tick();

      var msgEl = root.querySelector('[data-mn-delivery-message]');
      if (msgEl) {
        // Date conseillée dans la politique d'expédition (délais indicatifs de
        // 7 à 15 jours ouvrés) : ne jamais annoncer une date plus tardive.
        var orderCutoff = new Date(mcfg.orderDeadline || '2026-10-15T23:59:59+02:00');
        var fmt = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long' });
        var nowMsg = new Date();
        if (nowMsg <= orderCutoff) {
          msgEl.textContent =
            'Pour une livraison estimée avant Halloween, commande avant le ' +
            fmt.format(orderCutoff) +
            ' (délai indicatif : 7 à 15 jours ouvrés).';
        } else {
          msgEl.textContent =
            'Une livraison avant Halloween devient peu probable pour une nouvelle commande : délai indicatif de 7 à 15 jours ouvrés.';
        }
      }
    });
  }

  function findCartIcon() {
    return (
      document.querySelector('[href*="/cart"] svg') ||
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('[id*="cart-icon"]') ||
      document.querySelector('cart-icon') ||
      document.querySelector('header')
    );
  }

  function spawnGhost(originEl) {
    if (prefersReducedMotion()) return;
    var target = findCartIcon();
    if (!originEl || !target) return;
    var from = originEl.getBoundingClientRect();
    var to = target.getBoundingClientRect();

    var ghost = document.createElement('span');
    ghost.textContent = '👻';
    ghost.setAttribute('aria-hidden', 'true');
    ghost.style.cssText =
      'position:fixed; z-index:9999; font-size:22px; pointer-events:none; ' +
      'left:' + (from.left + from.width / 2) + 'px; top:' + (from.top + from.height / 2) + 'px; ' +
      'transform: translate(-50%,-50%); opacity:1; transition: transform 0.7s ease-in, opacity 0.7s ease-in;';
    document.body.appendChild(ghost);

    requestAnimationFrame(function () {
      var dx = to.left + to.width / 2 - (from.left + from.width / 2);
      var dy = to.top + to.height / 2 - (from.top + from.height / 2);
      ghost.style.transform = 'translate(calc(-50% + ' + dx + 'px), calc(-50% + ' + dy + 'px)) scale(0.4)';
      ghost.style.opacity = '0';
    });

    setTimeout(function () {
      ghost.remove();
    }, 750);
  }

  function initMagicAddToCart() {
    if (cfg.magicCart === false) return;
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest(
        'form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button, ' +
          '[data-mn-beast-add], [data-mn-magic-trigger]'
      );
      if (!trigger || trigger.disabled) return;
      spawnGhost(trigger);
      // La progression vers la livraison offerte est affichée dans le tiroir
      // panier (snippet mn-free-shipping), mise à jour à chaque ajout.
    });
  }

  function initEasterEgg() {
    if (cfg.easterEggs === false) return;
    var mcfg = window.MascaradeConfig || {};
    var code = mcfg.ghostHuntCode;
    if (!code) return;

    var sequence = [
      'ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown',
      'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight',
      'b', 'a',
    ];
    var progress = 0;

    function showReveal() {
      if (document.querySelector('.mn-ghost-hunt')) return;

      var overlay = document.createElement('div');
      overlay.className = 'mn-ghost-hunt';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Code secret débloqué');
      overlay.style.cssText =
        'position:fixed; inset:0; z-index:10000; display:flex; align-items:center; ' +
        'justify-content:center; background:rgba(13,11,14,0.85); padding:16px;';

      var card = document.createElement('div');
      card.style.cssText =
        'background: var(--mn-aubergine); border:1px solid var(--mn-orange); border-radius:16px; ' +
        'max-width:340px; width:100%; padding:24px; text-align:center; ' +
        'font-family: var(--mn-font-body); color: var(--mn-bone);';

      var h2 = document.createElement('h2');
      h2.style.cssText = 'font-family: var(--mn-font-title); font-size:22px; margin:0 0 10px;';
      h2.textContent = '👻 Tu as trouvé le fantôme !';
      card.appendChild(h2);

      var p = document.createElement('p');
      p.style.cssText = 'margin:0 0 16px; font-size:14px; opacity:0.85;';
      p.textContent = 'Utilise ce code pour une réduction sur ta prochaine commande :';
      card.appendChild(p);

      var codeRow = document.createElement('div');
      codeRow.style.cssText =
        'display:flex; gap:8px; align-items:center; justify-content:center; margin-bottom:18px;';

      var codeEl = document.createElement('code');
      codeEl.textContent = code;
      codeEl.style.cssText =
        'font-size:18px; font-weight:700; letter-spacing:1px; padding:8px 14px; ' +
        'border-radius:8px; background:rgba(255,255,255,0.08); border:1px dashed var(--mn-orange);';
      codeRow.appendChild(codeEl);

      var copyBtn = document.createElement('button');
      copyBtn.type = 'button';
      copyBtn.textContent = 'Copier';
      copyBtn.style.cssText =
        'min-height:44px; padding:0 16px; border-radius:999px; border:none; ' +
        'background: var(--mn-orange-hot); color: var(--mn-night); font-weight:700; cursor:pointer;';
      copyBtn.addEventListener('click', function () {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(function () {
            copyBtn.textContent = '✓ Copié';
            setTimeout(function () {
              copyBtn.textContent = 'Copier';
            }, 2000);
          });
        }
      });
      codeRow.appendChild(copyBtn);
      card.appendChild(codeRow);

      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.textContent = 'Fermer';
      closeBtn.style.cssText =
        'min-height:44px; padding:0 16px; border-radius:999px; border:1px solid var(--mn-orange); ' +
        'background:none; color: var(--mn-bone); cursor:pointer;';
      function close() {
        overlay.remove();
        document.removeEventListener('keydown', onOverlayKeydown);
      }
      function onOverlayKeydown(e) {
        if (e.key === 'Escape') close();
      }
      closeBtn.addEventListener('click', close);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close();
      });
      document.addEventListener('keydown', onOverlayKeydown);
      card.appendChild(closeBtn);

      overlay.appendChild(card);
      document.body.appendChild(overlay);
      copyBtn.focus();
    }

    document.addEventListener('keydown', function (e) {
      var expected = sequence[progress];
      var key = e.key.length === 1 ? e.key.toLowerCase() : e.key;
      if (key === expected) {
        progress += 1;
        if (progress === sequence.length) {
          progress = 0;
          showReveal();
        }
      } else {
        progress = key === sequence[0] ? 1 : 0;
      }
    });
  }

  function boot() {
    initMotionToggle();
    initScrollReveal();
    initCandleProgress();
    initFlashCursor();
    initBatTrail();
    initEmbers();
    initFog();
    initVisibilityPause();
    initCountdowns();
    initMagicAddToCart();
    initEasterEgg();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', initCountdowns);
})();
